import { render, staticRenderFns } from "./DFRadio.vue?vue&type=template&id=1511fb94&"
import script from "./DFRadio.vue?vue&type=script&lang=js&"
export * from "./DFRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports